import { Component } from '@angular/core';

/** Component used to display admin module header */
@Component({
  selector: 'mtx-router-header',
  standalone: false,
  templateUrl: './router-header.component.html',
})
export class RouterHeaderComponent { }
